module.exports = __webpack_public_path__ + "static/media/terms_services.e06265f7.svg";